const WhyIMadeThis = () => (
  <section className="bg-background pb-12 sm:pb-16">
    <div className="reading-column px-6">
      <h2 className="font-serif text-3xl text-foreground sm:text-4xl">
        Why I made this page
      </h2>
      <div className="mt-6 space-y-5 text-lg text-foreground/85">
        <p>
          I didn't want other women to feel the way I did — quietly frustrated, quietly tired,
          quietly hard on themselves.
        </p>
        <p>
          So I started writing things down. The small things that helped. The honest parts.
          The pieces I wish someone had told me.
        </p>
      </div>
    </div>
  </section>
);

export default WhyIMadeThis;
